export default __webpack_public_path__ + "static/media/1-Tier.eb726b1b.svg";